import React, { ReactNode } from "react";
import styled from "styled-components";
import Legend from "@charty/legend";
import { Item, Item as Serie } from "@charty/legend/item/model";
import Tooltip from "@charty/tooltip/serie";
import { Locale } from "@linkfluence/models/locale";
import { useDatasetTotal, useLegendSeries, useSortSeries } from "../data";

interface IProps {
  series: Serie[];
  locale: Locale;
  setHovered: (id: string) => void;
  total?: number;
  onClickLegend?: (uid: Serie["id"]) => void;
  tooltip?: (serie: Item, total: number) => ReactNode;
  orderBy?: "natural" | "numeric";
  disableAnimation?: boolean;
}
const HorizontalLegend = styled(Legend)`
  margin-bottom: 12px;
`;

const DoughnutChartLegendHorizontal = React.memo(
  ({
    series,
    total,
    locale,
    setHovered,
    tooltip,
    onClickLegend,
    orderBy = "natural",
    disableAnimation,
  }: IProps) => {
    const legendSeries = useSortSeries(useLegendSeries(series), orderBy);
    const datasetTotal = useDatasetTotal(total, series);

    return (
      <HorizontalLegend
        withOrder
        items={legendSeries}
        setHovered={setHovered}
        align="center"
        locale={locale}
        onClickSerie={onClickLegend}
        tooltip={
          tooltip
            ? (serie) => tooltip(serie, datasetTotal)
            : (serie) => (
                <Tooltip
                  locale={locale}
                  count={serie.count}
                  label={serie.label}
                  color={serie.color}
                  total={datasetTotal}
                  withSubLabel
                />
              )
        }
        disableAnimation={disableAnimation}
        magicWandCursor
      />
    );
  }
);

export default DoughnutChartLegendHorizontal;
